export const PAGE_META = {
  '/': {
    title: 'עורך דין חדלות פירעון והוצאה לפועל | מיכלסון ושות׳',
    description:
      'מתמודדים עם חובות, עיקולים או תיק בהוצאה לפועל? משרד מיכלסון ושות׳ מלווה חייבים בהליכי חדלות פירעון, הסדרי חוב וביטול עיקולים.',
  },
  '/insolvency-lawyer': {
    title: 'עורך דין חדלות פירעון | מחיקת חובות ושיקום כלכלי',
    description:
      'מתמודדים עם חובות, עיקולים או לחץ מהנושים? משרד מיכלסון ושות׳ מלווה חייבים בהליכי חדלות פירעון, מחיקת חובות וקבלת הפטר.',
  },
  '/execution-lawyer': {
    title: 'עורך דין הוצאה לפועל | עיקולים, חובות ואיחוד תיקים',
    description:
      'קיבלתם אזהרה מהוצאה לפועל, עיקול או הגבלה? משרד מיכלסון ושות׳ מלווה חייבים בהליכי הוצאה לפועל, הסדרי חוב ואיחוד תיקים.',
  },
  '/debt-settlement-lawyer': {
    title: 'עורך דין להסדר חובות | הפחתת חובות ומו״מ מול נושים',
    description:
      'מתמודדים עם חובות ולא יודעים איך לצאת מזה? משרד מיכלסון ושות׳ מלווה חייבים בגיבוש הסדרי חוב, מו״מ מול נושים והפחתת חובות במקרים המתאימים.',
  },
  '/company-liquidation': {
    title: 'פירוק חברה מרצון | סגירת חברה ברשם החברות',
    description:
      'רוצים לסגור חברה לא פעילה או לפרק חברה מרצון? משרד מיכלסון ושות׳ מלווה בעלי מניות ודירקטורים בהליך פירוק חברה מול רשם החברות.',
  },
  '/monetary-claims-lawyer': {
    title: 'עורך דין תביעות כספיות | הגשת תביעה וגביית חובות',
    description:
      'חייבים לכם כסף או קיבלתם תביעה כספית? משרד מיכלסון ושות׳ מלווה לקוחות בהגשת תביעות כספיות, כתבי הגנה וניהול הליכים משפטיים.',
  },
};

export const getPageMeta = (path) => {
  const normalized = path?.replace(/\/$/, '') || '/';
  return PAGE_META[normalized] || PAGE_META['/'];
};
